var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-follow",
    transform: "translate(-20.951 -4.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M36.653,10.563l-.147.151L24.456,14.99l.052-1.675,10-3.55L22.93,5.655V20.113H20.951V4.987l.163-.182a3.039,3.039,0,0,1,1.762-.68l.259-.012L36.521,8.864l.149.164A1.164,1.164,0,0,1,36.653,10.563Z",
    fill: "#be2126"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red-flag.662fa9e7.svg";
export { ForwardRef as ReactComponent };